import { Directive, ElementRef, Input, OnChanges, PLATFORM_ID, SimpleChanges, inject } from '@angular/core';
import { MatListOption } from '@angular/material/list';
import { isPlatformBrowser } from '@angular/common';
import { coerceBooleanProperty } from '@angular/cdk/coercion';

// if you set one mat-list-option items property
// ldwScrollIntoView to true
// this directive scrolls to this option and
// focus it
// based on https://stackblitz.com/edit/scroll-into-view-demo-select-list
// but has problems with virtual scrolling
@Directive({
    selector: 'mat-list-option[ldwScrollIntoView]',
    standalone: false
})
export class ScrollIntoViewDirective implements OnChanges {
  private platformId = inject(PLATFORM_ID);
  private elementRef = inject(ElementRef);
  private matListOption = inject(MatListOption);

  @Input() ldwScrollIntoView: boolean | undefined;

  ngOnChanges(simpleChange: SimpleChanges) {
    if (isPlatformBrowser(this.platformId)) {
      if (coerceBooleanProperty(this.ldwScrollIntoView)) {
        this.matListOption.focus();
      }
    }
  }
}
